
        import { isLoggedIn, loginWithDiscord, initGoogleSignIn } from '/src/auth.ts';

        // If already logged in, redirect to home
        if (isLoggedIn()) {
            const redirectBack = localStorage.getItem('discord_redirect_back') || '/';
            localStorage.removeItem('discord_redirect_back');
            window.location.href = redirectBack;
        }

        // Discord login
        document.getElementById('discordLoginBtn').addEventListener('click', () => loginWithDiscord());

        // Google login
        const waitForGoogle = setInterval(() => {
            if (window.google?.accounts?.id) {
                clearInterval(waitForGoogle);
                initGoogleSignIn(document.getElementById('googleLoginBtn'));
            }
        }, 100);
        setTimeout(() => clearInterval(waitForGoogle), 5000);
    